import React from 'react'
import { connect } from 'react-redux'
import { withStyles, Typography, Paper } from '@material-ui/core'
import { getGarageDescription } from '../../store/garage/selectors'

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  }
})

const ServicesDescriptionBase = ({ description, classes }) => {
  return (
    <Paper className={classes.root}>
      <Typography variant="h5">Prenota il tuo appuntamento</Typography>
      {description.map((line, index) => (
        <Typography key={index} variant="body1">
          {line}
        </Typography>
      ))}
    </Paper>
  )
}

export const ServicesDescription = withStyles(styles)(ServicesDescriptionBase)

const mapStateToProps = state => ({
  description: getGarageDescription(state)
})

export default connect(mapStateToProps)(ServicesDescription)
